import { CircularProgress, Fab, List, ListItem,ListItemIcon,ListItemSecondaryAction,ListItemText, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { Delete } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { FileIcon } from 'react-file-icon';
import Rest from '../../../../helpers/Rest';
import { useDocuments } from './DocumentsContext';

const localStyles = makeStyles(theme => {
    return {
    root: {
        "& .MuiListItemIcon-root": {
            width: theme.spacing(7),
            padding: theme.spacing(1)
        }
    }
}})

const TYPES = [
    /^application\/pdf/, "acrobat",
    /^audio\/.*/, "audio",
    /^application\/.*zip.*/, "compressed",
    /^application\/.*word.*/,  "document",
    /^image\/.*/, "image",
    /^(?:application\/vnd\.(?:ms-excel|.+\.sheet$)|text\/csv)/, "spreadsheet",
    /^application\/vnd\.(?:ms-powerpoint|.*presentation.*)/, "presentation",
    /^image\/svg\+xml$/, "vector",
    /^video\/.+/, "video",
    /^text\/.*/, "document",
]

function getIconType(mimeType){
    for (let i = 0, reg = TYPES[0]; reg; reg = TYPES[i += 2]){
        if (reg.test(mimeType)){
            return TYPES[i + 1]
        }
    }
    return "binary"    
}

async function downloadFile(deviceId, name, originalName){
    const blob = await Rest.getBinary(`documents/${deviceId}/${name}`)
    const a = document.createElement("a")
    a.href = URL.createObjectURL(blob)
    a.download = originalName
    a.click()
}

function getExtension(name){
    const match = /\.([^.]+)$/.exec(name)
    return match && match[1]
}

function Item({document, deviceId}){
    const {documents, setDocuments} = useDocuments()
    const [downloading, setDownloading] = React.useState(false)

    const {original_file_name, file_name, title, mime_type} = document
    return <ListItem onClick={() => {
        if (!downloading){
            setDownloading(true)
            downloadFile(deviceId, file_name, original_file_name).then(() => setDownloading(false))
        }
    }} button>
        <ListItemIcon><FileIcon type={getIconType(mime_type)} extension={getExtension(file_name)}/></ListItemIcon>
        <ListItemText primary={title} secondary={original_file_name} />
        <ListItemSecondaryAction>
            {downloading ? <CircularProgress size={24} /> :
            <Fab edge="end" onClick={() => {
                if (!window.confirm(`Are you sure you want to delete ${original_file_name}?`)){
                    return
                }
                setDownloading(true)
                Rest.del(`documents/${deviceId}/${file_name}`).then(() => {
                    setDocuments(documents.filter(d => d !== document))
                })
                }} color="primary" size="small">
                    <Delete />
            </Fab>}
        </ListItemSecondaryAction>
    </ListItem>
}

export function DocumentList({deviceId}){
    const {documents} = useDocuments()
    const classes = localStyles(useTheme())

    return <Box className={classes.root}>
        <List>
            {(documents || []).map(doc => <Item key={doc.file_name} document={doc} deviceId={deviceId} />)}
        </List>
    </Box>
}